var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMission03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.2103 150.2C116.687 150.2 150.31 116.577 150.31 75.1C150.31 33.6234 116.687 0 75.2103 0C33.7338 0 0.110352 33.6234 0.110352 75.1C0.110352 116.577 33.7338 150.2 75.2103 150.2Z",
    fill: "url(#paint0_linear_339_496)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2101 133.23C107.314 133.23 133.34 107.204 133.34 75.1C133.34 42.9957 107.314 16.97 75.2101 16.97C43.1058 16.97 17.0801 42.9957 17.0801 75.1C17.0801 107.204 43.1058 133.23 75.2101 133.23Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_339_496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.4599 91.1801H78.7099C79.0299 90.9501 79.3799 90.7701 79.7499 90.6401H80.2099C80.4899 90.5101 80.7999 90.4501 81.0999 90.4601H81.5599C81.9099 90.3501 82.2699 90.2601 82.6299 90.2101H82.8799L84.1699 90.0301H103.72V49.0701H87.8499C81.9299 49.0701 77.1299 53.8701 77.1299 59.7901L77.2699 91.8501C77.6399 91.5801 78.0299 91.3601 78.4499 91.1701L78.4599 91.1801Z",
    fill: "#A952A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.99 56.3601V91.5701C106.99 91.5701 106.99 91.6201 106.99 91.6401C106.97 92.5301 106.23 93.2301 105.35 93.2101H87.8704C78.8604 93.2101 77.1504 95.8201 77.1504 99.7501V100.54C80.9704 97.5701 87.4404 97.5701 90.7704 97.5701H110.82L110.93 56.3501H107L106.99 56.3601Z",
    fill: "#A952A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5197 90.7901H66.8397L68.1597 90.9701H68.4097L69.4797 91.2201H69.9397C70.2397 91.2401 70.5497 91.3001 70.8297 91.4001H71.2897L72.3297 91.9401H72.5797C72.9597 92.1901 73.3497 92.4201 73.7597 92.6201V59.8001C73.7797 53.8701 68.9797 49.0701 63.0597 49.0701H47.1797V90.7901H65.5197Z",
    fill: "#A952A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.06 93.3301H45.58C44.69 93.2901 43.97 92.5801 43.94 91.6901V56.3601H40V97.5101H59.91C63.48 97.5101 69.99 97.5101 73.82 100.55L73.78 99.8701C73.78 95.9401 71.99 93.3301 63.06 93.3301Z",
    fill: "#A952A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_339_496",
    x1: 18.6704,
    y1: 124.52,
    x2: 130.84,
    y2: 26.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA52A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#C56EC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D982D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#E58EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA92EA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_339_496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.92,
    height: 51.55,
    fill: "white",
    transform: "translate(40 49)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission03);
export default __webpack_public_path__ + "static/media/Mission-03.8cc7ea1ac07557d31d3b013d28d09c59.svg";
export { ForwardRef as ReactComponent };